<div class="contenedor-renderizador-dinamico">
  @if (tieneError()) {
    <div class="renderizador-dinamico__error">
      <span class="renderizador-dinamico__error-icono">⚠️</span>
      <p class="renderizador-dinamico__error-mensaje">No se pudo cargar el componente</p>
    </div>
  } @else if (usarPlaceholder()) {
    <div class="renderizador-dinamico__placeholder">
      <p class="renderizador-dinamico__placeholder-mensaje">Componente no disponible</p>
    </div>
  }
  <ng-container #contenedorDinamico></ng-container>
</div>
